jQuery(function($) {
	$('.jsA-request-form-content').on('keyup', ':input', (e) => {
		$('.request-form__element :input').each((i, e) => {
			let $element = $(e);
			let hasText = Number($element.val()) > 0 || $element.val().length > 0;

			$element.closest('.jsA-element-wrapper').toggleClass('input-wrapper--has-text', hasText);
		});
	});

	$('.jsA-request-form-consent-more-button').on('click', (e) => {
		$('.jsA-request-form-consent-more').removeClass('d-none');
		$(e.target).remove();
	});

	// keyboard
	$(document).on('keydown', '*[tabindex="0"]', function(e) {
		var $target = $(e.target);
		var code = (e.keyCode ? e.keyCode : e.which);
		if((code === 32 || code === 13) && !$target.is('a')) {
			$(this).click();
			return false;
		}
	});

	$('.accordion__title').on('click', function (){
		$(this).toggleClass('closed');
		$(this).next('.accordion__content').toggle('fast');
	});

	$('.site-navigation__search-button').on('click', (e) => {
		let $element = $('.site-navigation__search-input');
		const isVisible = $element.is(':visible');
		const value = $element.val();

		if(isVisible && value) {
			return true;
		} else if (!isVisible) {
			e.preventDefault();
			$element.removeClass('d-none');
			$element.focus();
			$element[0].selectionStart = $element[0].selectionEnd = value.length;
		} else {
			e.preventDefault();
			$element.addClass('d-none');
		}
	});
});

if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function() {
	const lazyElements = document.querySelectorAll( '[data-src]' );

	if (
		'IntersectionObserver' in window &&
		'intersectionRatio' in window.IntersectionObserverEntry.prototype
	) {
		const observer = new IntersectionObserver( entries => {
			const intersectingEntries = entries.filter( ( entry ) => entry.intersectionRatio > 0 );

			intersectingEntries.forEach( ( entry ) => {
				setRealSrc( entry.target );
				observer.unobserve( entry.target );
			} );
		}, {
			rootMargin: '50px 0px 50px 0px'
		});

		lazyElements.forEach( ( element ) => observer.observe( element ) );
	} else {
		lazyElements.forEach( ( element ) => setRealSrc( element ) );
	}

	function setRealSrc( element ) {
		element.setAttribute( 'src', element.getAttribute( 'data-src' ) );
		element.removeAttribute( 'data-src' );
	}
}());

jQuery(function(_) {
	const form = document.querySelector( '.wpcf7-form' );

	if ( ! form ) {
		return;
	}

	form.addEventListener( 'wpcf7submit', function ( e ) {
		form.querySelector( '.wpcf7-response-output' ).scrollIntoView();
	});
});

/**
 * Prevents Verity Chat button obscuring the Request Info form
 * by toggling its visibility based on the form's position
 */
jQuery(function () {
	const requestForm = document.querySelector( '.request-form' );

	if ( ! requestForm ) {
		return;
	}

	let observer = new IntersectionObserver( ( entries ) => {
		const intersectingEntries = entries.filter( ( entry ) => entry.isIntersecting );

		if ( 1 > intersectingEntries.length ) {
			document.body.classList.remove( 'hci-vc-hidden' );
		} else {
			document.body.classList.add( 'hci-vc-hidden' );
		}
	}, {
		rootMargin: getTopOffset() + " 0px 0px 0px"
	} );

	function getTopOffset() {
		return ( -1 * ( window.innerHeight - 64 ) ) + 'px';
	}

	function initObserver() {
		observer.observe( requestForm );
	}

	function cancelObserver() {
		observer.unobserve( requestForm );
	}

	window.addEventListener( 'resize', () => {
		if ( 768 > window.innerWidth ) {
			initObserver();
		} else {
			cancelObserver();
			document.body.classList.remove( 'hci-vc-hidden' );
		}
	} );

	if ( 768 > window.innerWidth ) {
		initObserver();
	}
});
